import { render, staticRenderFns } from "./FormBoxContentsRow.vue?vue&type=template&id=2ce6f862&scoped=true"
import script from "./FormBoxContentsRow.vue?vue&type=script&lang=js"
export * from "./FormBoxContentsRow.vue?vue&type=script&lang=js"
import style0 from "./FormBoxContentsRow.vue?vue&type=style&index=0&id=2ce6f862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce6f862",
  null
  
)

export default component.exports